/**
 * The one rule for the name an event is shown under, applied where rows
 * become wire (the app's access read, the Link in Bio row mappers and the
 * fan-page resolver) so every renderer shows `title` verbatim.
 *
 * An authored title wins. A stored title that is empty or is nothing more
 * than the organiser's own name — the shape SoundCharts imports arrive in —
 * is generic, and a generic event is named "Artist at Venue" (the artist
 * alone with no venue, the venue alone with no artist).
 */
export function eventDisplayTitle(input: {
  title: string | null | undefined;
  venue: string | null | undefined;
  artistName?: string | null;
}) {
  const title = input.title?.trim() ?? "";
  const venue = input.venue?.trim() ?? "";
  const artist = input.artistName?.trim() ?? "";
  const generic =
    !title || (!!artist && title.toLowerCase() === artist.toLowerCase());
  if (!generic) return title;
  if (artist && venue) return `${artist} at ${venue}`;
  return artist || venue || title;
}
